import { ApplicationListItem } from '../../application.model';
import {
  ApplicationsListGridData,
  ApplicationsListGridItem,
  ApplicationsListPersistedPagination
} from './applications-list.models';

export function getPaginationPage(pagination: ApplicationsListPersistedPagination): number {
  if (pagination.page) {
    return pagination.page;
  }
  return Math.floor(pagination.firstRowOffset / pagination.pageSize) + 1;
}

export function getMatchingGridData(
  gridData: ApplicationsListGridData | null,
  pagination: ApplicationsListPersistedPagination,
  requestedPage: number
): ApplicationsListGridData | null {
  if (!gridData || getPaginationPage(pagination) !== requestedPage) {
    return null;
  }
  return gridData;
}

export function mapApplicationListItemToGridItem(item: ApplicationListItem): ApplicationsListGridItem {
  return {
    id: item.id,
    studentId: item.studentId,
    companyId: item.companyId,
    appliedDate: item.appliedDate,
    studentName: item.studentName,
    companyName: item.companyName,
    jobRole: item.jobRole,
    jdLink: item.jdLink || item.jobDescriptionLink1 || '',
    jobDescriptionText: item.jobDescriptionText,
    applicationByName: item.applicationByName,
    resume: !!(item.resumeId || item.resumeTailoredId || item.resumeTailored),
    coverLetter: !!(item.coverLetterId || item.hasCoverLetter || item.coverLetter),
    resumeUrl: item.resumeDocumentId || item.resumeTailoredId || item.resumeUrl,
    resumeDocumentId: item.resumeDocumentId,
    coverLetterUrl: item.coverLetterId || item.coverLetterUrl,
    coverLetterId: item.coverLetterId,
    resumeFileName: item.resumeFileName,
    coverLetterFileName: item.coverLetterFileName,
    isRelatable: item.isRelatable ?? false
  };
}